/* eslint-disable arrow-body-style */
import { Box, Grid2, Typography } from '@mui/material';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import InputField from '../../../components/InputField';

export default function InvoiceAddress() {
  const { t } = useTranslation('checkout');
  const fields = useMemo(() => [
    {
      name: 'invoiceAddress.forename',
      label: t('invoiceAddress.forename'),
      required: true,
      gridSize: { xs: 12, md: 6 },
    },
    {
      name: 'invoiceAddress.name',
      label: t('invoiceAddress.name'),
      required: true,
      gridSize: { xs: 12, md: 6 },
    },
    {
      name: 'invoiceAddress.company',
      label: t('invoiceAddress.company'),
      gridSize: { xs: 12 },
    },
    {
      name: 'invoiceAddress.address1',
      label: t('invoiceAddress.address'),
      required: true,
      gridSize: { xs: 12 },
    },
    {
      name: 'invoiceAddress.postalCode',
      label: t('invoiceAddress.postalCode'),
      required: true,
      gridSize: { xs: 12, md: 3 },
    },
    {
      name: 'invoiceAddress.city',
      label: t('invoiceAddress.city'),
      required: true,
      gridSize: { xs: 12, md: 9 },
    },
    {
      name: 'invoiceAddress.country',
      label: t('invoiceAddress.country'),
      type: 'country',
      required: true,
      gridSize: { xs: 12, md: 12 },
    },
    {
      name: 'invoiceAddress.emailAddress',
      label: t('invoiceAddress.emailAddress'),
      type: 'email',
      required: true,
      gridSize: { xs: 12 },
    },
  ], []);

  return (
    <Box>
      <Typography variant="h5" gutterBottom sx={{ marginBottom: 4 }}>
        {t('steps.invoiceAddress')}
      </Typography>
      <Grid2 container spacing={2}>
        {fields.map((field) => (
          <InputField key={field.name} {...field} />
        ))}
      </Grid2>
    </Box>
  );
}
